import { IMode_Paiement } from "./Mode_Paiement.model";

export interface IPaiement {
  id?: number;
  type?: String;
  datePaiement?: any;
  montant?: any;
  mode_paiement?: IMode_Paiement;
}

export class Paiement implements IPaiement {
  constructor(
    public id?: number,
    public type?: string,
    public datePaiement?: any,
    public montant?: any,
    public mode_paiement?: IMode_Paiement
  ) {}
}
